<template>
    <div class="AuthLayout">
        <div id="view">
            <router-view />
        </div>
    </div>
</template>
